export default __webpack_public_path__ + "static/media/teachers_bg.aeb49c42.jpg";